import { createService } from "@/api/shared/service";
import type { TPatientFinancingPlan } from "./types";
import { createPathParamCRUD } from "@/api/shared/crud";

export * from "./types";

const SLUG = "patient/financing-plans";

export default createService(SLUG, {
  ...createPathParamCRUD<TPatientFinancingPlan>(SLUG),
});
